export enum EEventQueryKey {
  EVENTS = 'events'
}
